export default __webpack_public_path__ + "static/media/paste.5a62e8c2.svg";